/**
 * @file DeleteUserDialog.jsx
 * @description DeleteUserDialog component for displaying and managing delete user dialog.
 * @component DeleteUserDialog
 * @exports DeleteUserDialog - Main component for displaying and managing delete user dialog.
 */

import React from "react";
import { Button, Typography } from "@mui/material";
import { USER_STRINGS } from "../../../common/constants/adminModule/userConstants.js";
import { STRINGS, VARIANTS, BUTTON_COLORS } from "../../../common/constants/commonConstants.js";
import DialogComponent from "../../../common/components/DialogComponent.jsx";

const DeleteUserDialog = ({
    open,
    onConfirm,
    onClose,
}) => {
    return (
        <>
            <DialogComponent
                open={open}
                onClose={onClose}
                title={`${STRINGS.CONFIRM} ${STRINGS.DELETE}`}
                actions={
                    <Button
                        onClick={onConfirm}
                        color={BUTTON_COLORS.ERROR}
                        variant={VARIANTS.CONTAINED}
                    >
                        {STRINGS.DELETE}
                    </Button>
                }
            >
                <Typography variant={VARIANTS.BODY}>
                    {USER_STRINGS.CONFIRM_DELETE}
                </Typography>
            </DialogComponent>
        </>
    )
};

export default DeleteUserDialog;